import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CreateReferralInvite,
  ReferralEarningSummary,
  ReferralPageDto
} from '@umss/shared/data-access';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReferralService {
  private readonly apiUrl = '/api/Contractors/me/referrals';

  constructor(private http: HttpClient) {}

  generateReferralLink(
    contractorId: string
  ): Observable<{ referralLink: string }> {
    return this.http.post<{ referralLink: string }>(
      `${this.apiUrl}/referral-link`,
      { contractorId }
    );
  }

  getReferrals(): Observable<ReferralPageDto> {
    return this.http.get<ReferralPageDto>(`${this.apiUrl}`);
  }

  sendInvitation(invitations: CreateReferralInvite): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}`, invitations);
  }

  summary(): Observable<ReferralEarningSummary> {
    return this.http.get<ReferralEarningSummary>(`${this.apiUrl}/summary`);
  }
}
